import { AxiosService } from './axiosService';

export class RoleService extends AxiosService {
    async getRoles() {
        try {
            const { data } = await this.axios.get("/roles");
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const roleService = new RoleService();